module.exports = __webpack_public_path__ + "static/img/14d.ca864d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/14d.jpg
// module id = LrzD
// module chunks = 0